"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _ProjectUsersItem = require("./ProjectUsersItem");

var _ProjectUsersItem2 = _interopRequireDefault(_ProjectUsersItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProjectUsersList = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(ProjectUsersList, _Component);

  function ProjectUsersList() {
    (0, _classCallCheck3.default)(this, ProjectUsersList);
    return (0, _possibleConstructorReturn3.default)(this, (ProjectUsersList.__proto__ || (0, _getPrototypeOf2.default)(ProjectUsersList)).apply(this, arguments));
  }

  (0, _createClass3.default)(ProjectUsersList, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          userList = _props.userList,
          isAdmin = _props.isAdmin;

      if (!this.props.userList || !this.props.userList.length) {
        return this.renderEmptyMessage();
      }
      return this.renderCart();
    }
  }, {
    key: "renderEmptyMessage",
    value: function renderEmptyMessage() {
      return _react2.default.createElement(
        "div",
        { className: "voucher-order-cart" },
        _react2.default.createElement(
          "p",
          null,
          "Ei Kaytt\xE4ji\xE4."
        )
      );
    }
  }, {
    key: "renderCart",
    value: function renderCart() {
      return _react2.default.createElement(
        "table",
        { className: "table voucher-order-cart" },
        _react2.default.createElement(
          "thead",
          null,
          _react2.default.createElement(
            "tr",
            null,
            _react2.default.createElement(
              "th",
              null,
              "Yll\xE4pit\xE4j\xE4:"
            ),
            _react2.default.createElement(
              "th",
              null,
              "Projektik\xE4ytt\xE4j\xE4:"
            ),
            _react2.default.createElement(
              "th",
              null,
              "Email:"
            ),
            _react2.default.createElement("th", null)
          )
        ),
        _react2.default.createElement(
          "tbody",
          null,
          this.renderItems()
        )
      );
    }
  }, {
    key: "renderItems",
    value: function renderItems() {
      var _props2 = this.props,
          userList = _props2.userList,
          isAdmin = _props2.isAdmin,
          updateProjectUserByEmail = _props2.updateProjectUserByEmail;

      if (!userList || !userList.length) {
        return null;
      }

      return userList.map(function (item, index) {
        return _react2.default.createElement(_ProjectUsersItem2.default, {
          key: index,
          isAdmin: isAdmin,
          item: item,
          updateProjectUserByEmail: updateProjectUserByEmail
        });
      });
    }
  }]);
  return ProjectUsersList;
}(_react.Component), _class.propTypes = {
  userList: _react.PropTypes.array,
  updateProjectUserByEmail: _react.PropTypes.func.isRequired,
  isAdmin: _react.PropTypes.bool.isRequired
}, _temp);
exports.default = ProjectUsersList;
module.exports = exports["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/projects/ProjectUsersList.js
 ** module id = 1180
 ** module chunks = 0
 **/